import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/management/icn_management_01.png';
import icn_02 from '../../assets/img/landingPage/management/icn_management_02.png';
import icn_03 from '../../assets/img/landingPage/management/icn_management_03.png';

//key features
import key01 from '../../assets/img/landingPage/retail/retail_01.png';
import key02 from '../../assets/img/landingPage/retail/retail_02.png';
import key03 from '../../assets/img/landingPage/retail/retail_03.png';  
import key04 from '../../assets/img/landingPage/retail/retail_04.png';
import key05 from '../../assets/img/landingPage/retail/retail_05.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const Retail = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Create seamless commerce experiences',
            text: "Connect customer profiles, product catalogs, and sales orders to provide consistent, omnichannel shopping experiences across web, mobile, social, and in-store environments.",
            altDescription: "Connect customer profiles, product catalogs, and sales",
            image: key01,
        },
        Key_Feature_02: {
            title: "Transform business relationships",
            text: "Share data securely across your ecosystem — suppliers, partners, and internal teams — to improve collaboration, agility, and operational efficiency.",
            altDescription: "Share data securely across your ecosystem — suppliers, partners, and internal teams — to improve collaboration, agility, and operational efficiency.",
            image: key02,
        },
        Key_Feature_03: {
            title: 'Deliver personalized service',
            text: 
            "Equip your service agents with real-time access to customer data and order status, enabling quick, personalized support that boosts loyalty.",
            altDescription: 'Equip your service agents with real-time access to customer data and order status, enabling quick, personalized support that boosts loyalty.',
            image: key03,
        },
        Key_Feature_04: {
            title: 'Engage and retain customers',
            text: 
            "Integrate loyalty programs with customer interactions across every channel. Use AVAP Framework’s intelligent API management to drive personalized marketing campaigns and promotions that resonate.",
            altDescription: 'Integrate loyalty programs with customer interactions across every channel. Use AVAP Framework’s intelligent API management to drive personalized marketing campaigns and promotions that resonate.',
            image: key04,
        },
        Key_Feature_05: {
            title: 'Optimize store operations and associate productivity',
            text: 
            "Connect POS systems, inventory, and devices to give store associates real-time insights, helping them meet shopper expectations efficiently.",
            altDescription: 'Connect POS systems, inventory, and devices to give store associates real-time insights, helping them meet shopper expectations efficiently.',
            image: key05,
        },
    }

    //Key Benefits Bento
    const items = [
        {
          icon: icn_03,
          title: 'Unified Shopper View',
          paragraphs: [
            'Break down data silos by virtualizing APIs from all systems, creating a single, comprehensive view of your customers.',
        ]
        },
        {
          icon: icn_03,
          title: 'Real-Time Inventory Sync',
          paragraphs: [
            'Keep product availability up-to-date across all channels to reduce stockouts and improve customer satisfaction.',
          ]
        },
        {
          icon: icn_03,
          title: 'Accelerate Time to Market',
          paragraphs: [
            'Reuse virtual APIs and automate integrations to launch new services and campaigns faster.',
          ]
        },
        {
            icon: icn_03,
            title: 'Secure and Scalable',
            paragraphs: [
              'Built with enterprise-grade security, AVAP supports retail growth without compromising data privacy or performance.',
            ]
          },
    ];

    const breakpointColumnsObj = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };
    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">
                    <h1 className="fl-title-big m-0">AVAP for Retail</h1>
                    <p className="fl-title m-0 gradient-text">Accelerate retail innovation with intelligent API <br/> virtualization and automation.</p>
                                 <p className="fl-subtitle">
                                 Connect every shopper touchpoint and operational system seamlessly.
                                 </p>
                                {/* <p className="fl-text fl-txt-container" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform — 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p>*/}

                    
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-0 pb-2"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}                   
                </section>


                <div className="container text-center fl-card-border p-6">
                        
                     <h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Retail?</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                        The retail landscape is evolving rapidly. To stay competitive, retailers need to unify customer data, streamline operations, and deliver personalized experiences — all in real-time. AVAP for Retail empowers you to do exactly that with a virtual-first API platform built for flexibility, speed, and security.
                        
                        {/*Boton Contact Us*/}  
                        <a className="glowBtn-dark "  
                        href="/contact" 
                        target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                    </p>

                </div>


                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}

                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        {/*<img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />*/}
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>


                {/* Sección Key Benefits */}   
                {/*<section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                    Unified Shopper View
                                </p>
                                <p className="fl-text">
                                Break down data silos by virtualizing APIs from all systems, creating a single, comprehensive view of your customers.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                             
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Real-Time Inventory Sync
                                </p>
                                <p className="fl-text">
                                     Keep product availability up-to-date across all channels to reduce stockouts and improve customer satisfaction.

                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                          
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                     Accelerate Time to Market
                                </p>
                                <p className="fl-text">
                                Reuse virtual APIs and automate integrations to launch new services and campaigns faster.


                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                    Secure and Scalable
                                </p>
                                <p className="fl-text">
                                Built with enterprise-grade security, AVAP supports retail growth without compromising data privacy or performance.


                                </p>
                            </div>
                        </div>
                    </div>
                </section>*/}

                {/* Sección built for secure */} 
                <section className="container pt-8">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="">
                                    <h3 className='text-center fl-title'>Ready to revolutionize your retail experience?</h3>
                                    <p className='text-center'>Contact us today to learn how AVAP can transform your retail ecosystem with intelligent API virtualization and automation.
                                    </p>
                                  {/*Boton Contact Us*/}  
                                  <a className="glowBtn-dark " 
                                    style={{ zIndex: 2,}} 
                                    href="/contact" 
                                    target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Retail;
